import {
  TASKS_REQUEST,
  TASKS_FAILURE,
  FETCH_TASKS_SUCCESS,
  CREATE_TASK_SUCCESS,
  UPDATE_TASK_SUCCESS,
  DELETE_TASK_SUCCESS,
  FETCH_TASK_STATISTICS_SUCCESS,
} from "../action/types";
import { getEntityId, getListRows, getListTotal } from "../../utils/taskManagements";

const initialState = {
  tasks: [],
  total: 0,
  loading: false,
  error: null,
  statistics: null,
  statisticsLoading: false,
};

const upsertTask = (tasks, task) => {
  const taskId = getEntityId(task);
  if (!taskId) return tasks;

  const exists = tasks.some((item) => getEntityId(item) === taskId);
  if (!exists) return [task, ...tasks];

  return tasks.map((item) =>
    getEntityId(item) === taskId ? { ...item, ...task } : item,
  );
};

const taskManagementsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case TASKS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_TASKS_SUCCESS:
      return {
        ...state,
        loading: false,
        tasks: getListRows(payload),
        total: getListTotal(payload),
      };

    case CREATE_TASK_SUCCESS:
      {
        const exists = state.tasks.some(
          (item) => getEntityId(item) === getEntityId(payload),
        );
        return {
          ...state,
          loading: false,
          tasks: upsertTask(state.tasks, payload),
          total: exists ? state.total : state.total + 1,
        };
      }

    case UPDATE_TASK_SUCCESS:
      return {
        ...state,
        loading: false,
        tasks: upsertTask(state.tasks, payload),
      };

    case DELETE_TASK_SUCCESS:
      return {
        ...state,
        loading: false,
        tasks: state.tasks.filter((item) => getEntityId(item) !== payload),
        total: Math.max(0, state.total - 1),
      };

    case TASKS_FAILURE:
      return {
        ...state,
        loading: false,
        statisticsLoading: false,
        error: payload,
      };

    case FETCH_TASK_STATISTICS_SUCCESS:
      return {
        ...state,
        statisticsLoading: false,
        statistics: payload,
      };

    default:
      return state;
  }
};

export default taskManagementsReducer;
